(function () {
  if (window.customElements && customElements.get('secondary-nav')) return;

  var HEADER_FALLBACKS = [
    '.shopify-section-group-header-group',
    '#shopify-section-header',
    'header[role="banner"]',
    'header.header',
    'header.site-header',
    'header',
    '.site-header',
    '.header'
  ];

  function bool(v) { return String(v) === 'true'; }

  function toArray(nodeList) { return Array.prototype.slice.call(nodeList); }

  function humanize(id) {
    var key = id.replace(/^shopify-section-/, '');
    var parts = key.split('__');
    var last = parts[parts.length - 1] || '';
    last = last.replace(/[-_]+/g, ' ').replace(/\d+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!last) return null;
    return last.charAt(0).toUpperCase() + last.slice(1);
  }

  function SecondaryNav() {
    return Reflect.construct(HTMLElement, [], SecondaryNav);
  }
  SecondaryNav.prototype = Object.create(HTMLElement.prototype);
  SecondaryNav.prototype.constructor = SecondaryNav;

  SecondaryNav.prototype.connectedCallback = function () {
    if (this._mounted) return;
    this._mounted = true;

    this.cfg = {
      autoDetect: bool(this.dataset.autoDetect),
      requireHeading: bool(this.dataset.requireHeading),
      smooth: bool(this.dataset.smooth),
      sticky: bool(this.dataset.sticky),
      spy: bool(this.dataset.spy),
      headerSelector: (this.dataset.headerSelector || '').trim()
    };

    this.section = this.closest('.secondary-nav') || this.closest('[id^="shopify-section-"]');
    this.bar = this.querySelector('.secondary-nav__bar');
    this.list = this.querySelector('.secondary-nav__list');
    this.indicator = this.querySelector('.secondary-nav__indicator');
    this.overrides = this.readOverrides();

    this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.lastTop = null;
    this.activeIdx = -1;
    this.targets = [];
    this.ticking = false;

    var self = this;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { self.init(); }, { once: true });
    } else {
      this.init();
    }
  };

  SecondaryNav.prototype.init = function () {
    if (this._inited) return;
    this._inited = true;

    this.headerEl = this.cfg.sticky ? this.findHeader() : null;

    this.build();

    if (!this.targets.length) {
      if (this.section) this.section.classList.add('secondary-nav--empty');
      return;
    }

    this.classList.add('secondary-nav__root--ready');
    this.bindEvents();
    this.onScroll();
    var self = this;
    requestAnimationFrame(function () {
      if (self.activeIdx < 0) self.setActive(0);
      else self.moveIndicator(self.targets[self.activeIdx].a, true);
    });
  };

  SecondaryNav.prototype.readOverrides = function () {
    var el = this.querySelector('.secondary-nav__overrides');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  };

  SecondaryNav.prototype.findHeader = function () {
    var self = this;
    function ok(node) { return node && self.section && !self.section.contains(node); }
    if (this.cfg.headerSelector) {
      var custom = document.querySelector(this.cfg.headerSelector);
      if (ok(custom)) return custom;
    }
    for (var i = 0; i < HEADER_FALLBACKS.length; i++) {
      var found = document.querySelector(HEADER_FALLBACKS[i]);
      if (ok(found)) return found;
    }
    return null;
  };

  SecondaryNav.prototype.resolveLabel = function (sec) {
    if (sec.hasAttribute('data-secnav-label')) {
      return sec.getAttribute('data-secnav-label').trim();
    }
    var labeled = sec.querySelector('[data-secnav-label]');
    if (labeled) return (labeled.getAttribute('data-secnav-label') || '').trim();
    var heading = sec.querySelector('[data-secnav-heading], h1, h2');
    if (heading && heading.textContent.trim()) return heading.textContent.trim();
    return null;
  };

  SecondaryNav.prototype.applyOverrides = function (label) {
    if (!label) return label;
    var lower = label.toLowerCase();
    for (var i = 0; i < this.overrides.length; i++) {
      var o = this.overrides[i];
      var match = (o.match || '').trim().toLowerCase();
      if (!match) continue;
      if (lower.indexOf(match) > -1) {
        if (o.hide) return null;
        if (o.label && o.label.trim()) return o.label.trim();
        return label;
      }
    }
    return label;
  };

  SecondaryNav.prototype.collectSections = function () {
    if (!this.cfg.autoDetect || !this.section) return [];
    var scope = this.section.parentElement || document.body;
    var siblings = toArray(scope.children).filter(function (n) {
      return n.id && n.id.indexOf('shopify-section-') === 0;
    });
    var self = this;
    return siblings.filter(function (n) { return n !== self.section; });
  };

  SecondaryNav.prototype.build = function () {
    var sections = this.collectSections();
    var frag = document.createDocumentFragment();
    var self = this;

    sections.forEach(function (sec) {
      var label = self.resolveLabel(sec);
      if (!label) {
        if (self.cfg.requireHeading) return;
        label = humanize(sec.id);
        if (!label) return;
      }
      label = self.applyOverrides(label);
      if (label === null) return;

      var a = document.createElement('a');
      a.className = 'secondary-nav__link';
      a.href = '#' + sec.id;
      a.setAttribute('data-target', sec.id);
      a.setAttribute('aria-current', 'false');
      a.textContent = label;

      frag.appendChild(a);
      self.targets.push({ a: a, el: sec });
    });

    if (this.indicator) this.list.insertBefore(frag, this.indicator);
    else this.list.appendChild(frag);
  };

  SecondaryNav.prototype.offsetLine = function () {
    var top = 0;
    if (this.section) {
      top = parseFloat(getComputedStyle(this.section).getPropertyValue('--secnav-top')) || 0;
    }
    return top + (this.bar ? this.bar.offsetHeight : 0);
  };

  SecondaryNav.prototype.moveIndicator = function (a, instant) {
    if (!this.indicator || !a) return;
    if (instant && this.indicator.style.transition !== 'none') {
      var prev = this.indicator.style.transition;
      this.indicator.style.transition = 'none';
      this.indicator.style.left = a.offsetLeft + 'px';
      this.indicator.style.width = a.offsetWidth + 'px';
      void this.indicator.offsetWidth;
      this.indicator.style.transition = prev;
      return;
    }
    this.indicator.style.left = a.offsetLeft + 'px';
    this.indicator.style.width = a.offsetWidth + 'px';
  };

  SecondaryNav.prototype.ensureVisible = function (a) {
    if (!a || this.list.scrollWidth <= this.list.clientWidth + 2) return;
    var target = a.offsetLeft - (this.list.clientWidth / 2) + (a.offsetWidth / 2);
    if (target < 0) target = 0;
    if (this.list.scrollTo) {
      this.list.scrollTo({ left: target, behavior: this.reduceMotion ? 'auto' : 'smooth' });
    } else {
      this.list.scrollLeft = target;
    }
  };

  SecondaryNav.prototype.setActive = function (idx) {
    if (idx < 0 || idx >= this.targets.length || idx === this.activeIdx) return;
    this.activeIdx = idx;
    for (var i = 0; i < this.targets.length; i++) {
      this.targets[i].a.setAttribute('aria-current', i === idx ? 'true' : 'false');
    }
    this.moveIndicator(this.targets[idx].a);
    this.ensureVisible(this.targets[idx].a);
  };

  SecondaryNav.prototype.trackHeader = function () {
    if (!this.headerEl || !this.section) return;
    var b = this.headerEl.getBoundingClientRect().bottom;
    if (b < 0) b = 0;
    b = Math.round(b);
    if (this.lastTop === null || Math.abs(b - this.lastTop) > 0.5) {
      this.section.style.setProperty('--secnav-top', b + 'px');
      this.lastTop = b;
    }
  };

  SecondaryNav.prototype.spy = function () {
    if (!this.cfg.spy || !this.targets.length) return;
    var line = this.offsetLine() + 6;
    var idx = 0;
    for (var i = 0; i < this.targets.length; i++) {
      if (this.targets[i].el.getBoundingClientRect().top - line <= 0) idx = i;
      else break;
    }
    this.setActive(idx);
  };

  SecondaryNav.prototype.onScroll = function () {
    this.trackHeader();
    this.spy();
  };

  SecondaryNav.prototype.scrollToTarget = function (el) {
    var line = this.offsetLine() + 8;
    var top = window.pageYOffset + el.getBoundingClientRect().top - line;
    if (top < 0) top = 0;
    if (window.scrollTo) {
      try { window.scrollTo({ top: top, behavior: this.cfg.smooth && !this.reduceMotion ? 'smooth' : 'auto' }); }
      catch (e) { window.scrollTo(0, top); }
    }
  };

  SecondaryNav.prototype.bindEvents = function () {
    var self = this;

    this.list.addEventListener('click', function (e) {
      var a = e.target.closest('.secondary-nav__link');
      if (!a) return;
      e.preventDefault();
      var el = document.getElementById(a.getAttribute('data-target'));
      if (!el) return;
      var idx = -1;
      for (var i = 0; i < self.targets.length; i++) {
        if (self.targets[i].a === a) { idx = i; break; }
      }
      if (idx > -1) self.setActive(idx);
      self.scrollToTarget(el);
    });

    var onScrollOrResize = function () {
      if (self.ticking) return;
      self.ticking = true;
      requestAnimationFrame(function () {
        self.onScroll();
        self.ticking = false;
      });
    };
    window.addEventListener('scroll', onScrollOrResize, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        self.lastTop = null;
        self.onScroll();
        if (self.activeIdx > -1) {
          self.moveIndicator(self.targets[self.activeIdx].a, true);
          self.ensureVisible(self.targets[self.activeIdx].a);
        }
      }, 120);
    });
  };

  if ('customElements' in window) {
    customElements.define('secondary-nav', SecondaryNav);
  }
})();